import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toast"];
  static values = { url: String };

  copy() {
    navigator.clipboard
      .writeText(this.urlValue)
      .then(() => {
        this.toastTarget.classList.remove("d-none");
        setTimeout(() => this.toastTarget.classList.add("d-none"), 2000);
      })
      .catch(() => {
        window.prompt("Copy this link:", this.urlValue);
      });
  }
}
